import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import ConnectedIntlProvider from "./ConnectedIntlProvider";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./store";
import { CookiesProvider } from "react-cookie";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import App from "./containers/App";

import "./static/style/index.css";

if (process.env.REACT_APP_SENTRY_DSN){
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_ENV,
    tracesSampleRate: 1.0
  });
}


render(
  <Provider store={store}>
    <ConnectedIntlProvider>
      <ConnectedRouter history={history}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </ConnectedRouter>
    </ConnectedIntlProvider>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js